import apiClient from '@/api/index'
import router from '@/router';

export const reportProductOrdersModule = {
    namespaced: true,

    state:() => ({
        reportData: {},
        reportLoading: true,
        filterset: {},
        filtersetLoading: true,
        filterSpecs: {},
        defaultDate: [],
        excelData: {},
    }),

    mutations: {
        setReportData(state, data) {
            state.reportData = data
        },

        setReportFilterset(state, data) {
            console.log(data);
            state.filterSpecs['category'] = []
            state.filterSpecs['date_range'] = []
            state.filterSpecs['group'] = []
            state.filterSpecs['product'] = []
            state.filterSpecs['shop'] = []
            state.filterSpecs['time_range'] = []

            if(Object.keys(router.currentRoute.value.query).length == 0) {
                for(let filter in data) {
                    if(filter !== 'title') {
                        for(let i = 0; i < data[filter].choices.length; i++) {
                            if(filter === 'date_range') {
                                state.filterSpecs[filter].push(data[filter].choices[i].value)
                            } else if(filter === 'time_range') {
                                state.filterSpecs[filter] = [
                                    {
                                        hours: data[filter].choices[0].value.split(':')[0],
                                        minutes: data[filter].choices[0].value.split(':')[1]
                                    },
                                    {
                                        hours: data[filter].choices[1].value.split(':')[0],
                                        minutes: data[filter].choices[1].value.split(':')[1]
                                    },
                                ]
                            } else {
                                if(data[filter].multi_choices) {
                                    if(data[filter].choices[i].checked) {
                                        state.filterSpecs[filter].push(data[filter].choices[i].value)
                                    }
                                } else {
                                    if(data[filter].choices[i].checked) {
                                        state.filterSpecs[filter] = data[filter].choices[i].value
                                    }
                                } 
                            }
                        }
                    }
                }
            } else {
                const queries = router.currentRoute.value.query
                for(let filter in data) {
                    if(data[filter].multi_choices) {
                        state.filterSpecs[filter] = []
                    } else {
                        state.filterSpecs[filter] = ''
                    }
                }

                for(let query in queries) {
                    if(query) {
                        if(typeof state.filterSpecs[query] !== 'undefined') {
                            if(typeof state.filterSpecs[query] !== 'string') {
                                if(typeof queries[query] !== 'string') {
                                    state.filterSpecs[query] = queries[query]
                                } else {
                                    state.filterSpecs[query].push(queries[query])
                                }
                            } else {
                                state.filterSpecs[query] = queries[query]
                            }
                        }
                    }
                }

                state.filterSpecs['date_range'] = []
                state.filterSpecs['time_range'] = []

                queries.date_from ? state.filterSpecs['date_range'].push(queries.date_from) : state.filterSpecs['date_range'].push('')
                queries.date_to ? state.filterSpecs['date_range'].push(queries.date_to) : state.filterSpecs['date_range'].push('')

                if(queries.time_from || queries.time_to) {
                    state.filterSpecs['time_range'] = [
                        {
                            hours: '00',
                            minutes: '00'
                        },
                        {
                            hours: '23',
                            minutes: '00'
                        }
                    ]

                    if(queries.time_from) {
                        state.filterSpecs['time_range'][0] = {
                            hours: queries.time_from.split(':')[0],
                            minutes: queries.time_from.split(':')[1]
                        }
                    }
                    if(queries.time_to) {
                        state.filterSpecs['time_range'][1] = {
                            hours: queries.time_to.split(':')[0],
                            minutes: queries.time_to.split(':')[1]
                        }
                    }
                }
            }
            
            state.filterset = data
            state.filtersetLoading = false
        },

        setExcelData(state, data) {
            state.excelData = data
        }
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true
            // Проверяет, есть ли параметры которые можно передать в запросе
            if(router.currentRoute.value.fullPath.split('?')[1]) {
                try {
                    const response = await apiClient.get("/reports/product_orders/data?" + router.currentRoute.value.fullPath.split('?')[1], {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    commit('setReportData', response.data.data)
                    commit('setExcelData', response.data)
                } catch(err) { // Если есть ошибка
                    console.log(err)
                }
            // Если нет, делать запрос без параметров
            } else {
                try {
                    const response = await apiClient.get("/reports/product_orders/data", {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    commit('setReportData', response.data.data)
                    commit('setExcelData', response.data)
                } catch(err) { // Если есть ошибка
                    console.log(err)
                }
            }

            state.reportLoading = false
        },

        async getReportFilterset({ commit, state }) {
            try {
                const response = await apiClient.get("/reports/product_orders/filterset", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                commit('setReportFilterset', response.data)
                state.filtersetLoading = false
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },

        resetFilters({ state }) {
            for(let filter in state.filterset) {
                state.filterSpecs[filter] = []

                if(filter !== 'title') {
                    for(let i = 0; i < state.filterset[filter].choices.length; i++) {
                        if(filter === 'date_range') {
                            state.filterSpecs[filter].push(state.filterset[filter].choices[i].value)
                        } else {
                            if(state.filterset[filter].choices[i].checked) {
                                state.filterSpecs[filter] = state.filterset[filter].choices[i].value
                            }
                        }
                    }
                }
            }
        },

        async getExcelFile({ state }) {
            try {
                const response = await apiClient.post("/reports/export_to_excel/",
                state.excelData,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    },
                    responseType: 'blob'
                })
                const now = new Date()
                const url = URL.createObjectURL(response.data)
                const a = document.createElement('a')
                a.href = url
                a.download = `${state.excelData.title}_${now.toLocaleDateString()}.xls`
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
                URL.revokeObjectURL(url)
                
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },
    }
}